import { Col, Row, Typography, Divider } from "antd";
import { useEffect, useState } from "react";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import InputComponent from "../../../components/InputComponent";
import { FileUploadItems, InputStyle, labelStyle } from "./constants";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import { useNewsContext } from "../../../context/NewsContext/NewsContext";
import RichTextComponent from "../../../components/RichTextComponent";
import TextareaComponent from "../../../components/TextareaComponent";

type NewsContentDetailProps = {
  isEnContent: boolean;
};

const NewsContentDetail: React.FC<NewsContentDetailProps> = ({ isEnContent }) => {
  const NEWS_DETAIL_INDEX = isEnContent ? 1 : 0;
  const { newsData, setNewsData } = useNewsContext();
  const [activeSameImages, setActiveSameImages] = useState<boolean>(false);
  const [shortNewsText, setShortNewsText] = useState("");
  const [longNewsText, setLongNewsText] = useState("");


  const handleFileChange = (fileData: FileData[] | null, key: string) => {
    setNewsData(prevState => {
      return {
        ...prevState,
        newsDetail: prevState.newsDetail.map((item, idx) => {
          if (idx === NEWS_DETAIL_INDEX) {
            return {
              ...item,
              [key]: fileData?.[0]?.file || null
            };
          }
          return item;
        })
      };
    });
  };

  const handleTitleChange = (value: string) => {
    setNewsData(prevState => {

      return {
        ...prevState,
        newsDetail: prevState.newsDetail.map((item, idx) => {
          if (idx === NEWS_DETAIL_INDEX) {
            return {
              ...item,
              title: value
            };
          }
          return item;
        })
      };
    });
  };

  const handleSetLongTextTemplate = (body: string) => {
    setLongNewsText(body);
  };

  useEffect(() => {
    setNewsData(prevState => {
      return {
        ...prevState,
        newsDetail: prevState.newsDetail.map((item, idx) => {
          if (idx === NEWS_DETAIL_INDEX) {
            return {
              ...item,
              shorText: shortNewsText
            };
          }
          return item;
        })
      };
    });
  }, [shortNewsText])

  useEffect(() => {
    setNewsData(prevState => {
      return {
        ...prevState,
        newsDetail: prevState.newsDetail.map((item, idx) => {
          if (idx === NEWS_DETAIL_INDEX) {
            return {
              ...item,
              text: longNewsText
            };
          }
          return item;
        })
      };
    });
  }, [longNewsText])

  useEffect(() => {
    setNewsData(prevState => {
      const updatedNewsDetail = prevState.newsDetail.map(detail => {
        if (detail.culture === "en-US" && !activeSameImages) {
          return {
            ...detail,
            imageUrl: null,
            smallImageUrl: null,
            mobileImageUrl: null,
            mobileSmallImageUrl: null
          };
        }
        return detail;
      });

      return {
        ...prevState,
        activeSameImages: activeSameImages,
        newsDetail: updatedNewsDetail
      };
    });
  }, [activeSameImages]);

  return (
    <>
      {isEnContent &&
        <SwitchOptionComponent
          labelStyle={labelStyle}
          key={"sameImages"}
          title={"Aynı görseller kullanılsın"}
          value={activeSameImages}
          onChange={(checked) =>
            setActiveSameImages(checked)
          }
        />
      }
      <Row gutter={20}>
        {!activeSameImages && FileUploadItems.map((item) => (
          <Col key={item.key} span={6}>
            <FileUploadComponent
              title={item.label}
              onChange={(fileData: FileData[] | null) => handleFileChange(fileData, item.key)}
              dimensions={item.dimensions}
              fileSize={item.fileSize}
              fileSizeText={item.fileSizeText}
              format={item.format}
            />
          </Col>
        ))}
      </Row>
      <Divider />
      <Row gutter={20}>
        <Col span={12}>
          <InputComponent
            title={"Başlık"}
            placeholder=""
            value={newsData?.newsDetail[NEWS_DETAIL_INDEX]?.title}
            style={InputStyle}
            isRequired
            onChange={(e) => handleTitleChange(e.target.value)}
          />
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={12}>
          <TextareaComponent
            title={"Kısa Metin"}
            placeholder=""
            value={shortNewsText}
            isRequired
            onChange={(e) => setShortNewsText(e.target.value)}
            rows={20}
          />
        </Col>
        <Col span={12}>
          <Typography.Title level={5} style={{ color: "#2e333e" }}>
            Uzun Metin
            <span style={{ color: "red" }}>&nbsp;*</span>
          </Typography.Title>

          <RichTextComponent
            handleSetChangedTemplate={handleSetLongTextTemplate}
            backgroundColor={"transparent"}
          />
        </Col>
      </Row>
    </>
  );
};

export default NewsContentDetail;
